<ng-template #actionButton>
  <iris-button
    [type]="IrisButtonTypes.PRIMARY"
    (click)="reviewedCostEstimation()"
    data-test="self-pay-cost-estimation-next-button"
  >
    Next
  </iris-button>
</ng-template>

@if (ratesLoading()) {
  <div class="rates-loading" data-test="self-pay-rates-loading">
    <iris-spinner [size]="'sm'"></iris-spinner>
  </div>
} @else if (ratesLoadError()) {
  <div class="rates-error" data-test="self-pay-rates-error">
    <iris-empty-state
      title="There was an error when submitting your request."
      details="Please try again."
      data-test="error-state"
    />
  </div>
} @else {
  <div class="cost-estimation-container">
    <div class="estimated-session-cost-card" data-test="estimated-session-cost-card">
      <h2 class="estimated-session-cost-heading">Estimated session cost</h2>

      <ul class="featured-estimates-list">
        @for (estimate of featuredEstimates(); track estimate.serviceLabel + estimate.amount) {
          <li class="featured-estimate-row">
            <div class="featured-estimate-label-block">
              <p class="featured-estimate-service">{{ estimate.serviceLabel }}</p>
            </div>
            <h2 class="featured-estimate-amount">{{ estimate.amount | currency:'USD':'symbol':'1.0-2' }}</h2>
          </li>
        }
      </ul>
    </div>
  </div>

  <p class="insurance-note" data-test="self-pay-insurance-note">
    You can add health insurance or other benefits anytime in your account.
  </p>

  <client-self-pay-cost-estimate-detailed [rates]="rates()" />

  <iris-button-container *ngIf="!fromDirectBooking()" [alignment]="IrisButtonContainerAlignments.END">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
  </iris-button-container>
}
